var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 7,
    viewBox: "0 0 15 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14652 0.146484L4.85363 0.853592L2.20718 3.50004L4.85363 6.14648L4.14652 6.85359L0.792969 3.50004L4.14652 0.146484Z",
    fill: "ingerit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2072 3.50004L10.8536 6.85359L10.1465 6.14648L12.793 3.50004L10.1465 0.853592L10.8536 0.146484L14.2072 3.50004Z",
    fill: "ingerit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 4.00004C7.77622 4.00004 8.00008 3.77618 8.00008 3.50004C8.00008 3.2239 7.77622 3.00004 7.50008 3.00004C7.22393 3.00004 7.00008 3.2239 7.00008 3.50004C7.00008 3.77618 7.22393 4.00004 7.50008 4.00004Z",
    fill: "ingerit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderHandle);
export default __webpack_public_path__ + "static/media/sliderHandle.1ed90d702ce7589691c000337dce02da.svg";
export { ForwardRef as ReactComponent };